import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { sanitizeClinicalHtml, looksLikeClinicalHtml } from '../../utils/clinicalHtml';

export interface ClinicalHtmlViewProps {
  html: string | null | undefined;
  sx?: SxProps<Theme>;
  emptyFallback?: React.ReactNode;
}

/** Exibe corpo clínico (HTML sanitizado ou texto plano com quebras). */
const ClinicalHtmlView: React.FC<ClinicalHtmlViewProps> = ({ html, sx, emptyFallback = '—' }) => {
  const raw = html == null ? '' : String(html);
  if (!raw.trim()) {
    return <>{emptyFallback}</>;
  }

  if (looksLikeClinicalHtml(raw)) {
    return (
      <Box
        className="clinical-html-view"
        sx={{
          color: '#374151',
          fontSize: '0.875rem',
          lineHeight: 1.7,
          '& ul, & ol': { pl: 3, my: 0.5 },
          '& li': { my: 0.25 },
          ...sx,
        }}
        dangerouslySetInnerHTML={{ __html: sanitizeClinicalHtml(raw) }}
      />
    );
  }

  return (
    <Box component="span" sx={{ color: '#374151', whiteSpace: 'pre-wrap', ...sx }}>
      {raw}
    </Box>
  );
};

export default ClinicalHtmlView;
